import { render, staticRenderFns } from "./HighlightsCard.vue?vue&type=template&id=4120d346&"
import script from "./HighlightsCard.vue?vue&type=script&lang=js&"
export * from "./HighlightsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports